module.exports = __webpack_public_path__ + "static/media/s2.6b69c816.jpg";